export default "__VITE_ASSET__BpYysODX__"